import { render, staticRenderFns } from "./class-list.vue?vue&type=template&id=2e05bcb0&scoped=true&"
import script from "./class-list.vue?vue&type=script&lang=js&"
export * from "./class-list.vue?vue&type=script&lang=js&"
import style0 from "./class-list.vue?vue&type=style&index=0&id=2e05bcb0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e05bcb0",
  null
  
)

export default component.exports